import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";
import toast from 'react-hot-toast';

// const initialState = {
//   name: "",
//   email: "",
//   message: "",
// };
export const Contact = (props) => {
  // const [{ name, email, message }, setState] = useState(initialState);
  const [ isSubmitting, setIsSubmitting ] = useState(false);
  const [ isSubmited, setIsSubmited ] = useState(false);
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setState((prevState) => ({ ...prevState, [name]: value }));
  // };
  // const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    // console.log(e.target);
    /* replace below with your own Service ID, Template ID and Public Key from your EmailJS account */ 
    return emailjs
      .sendForm("service_fv9z9im", "template_v6m8ly4", e.target, "IEnyAReiHgI6VYJ_J")
      .then(
        (result) => {
          console.log(result);
          setIsSubmitting(false);
          setIsSubmited(true)
          toast.success("Email sent!")
        },
        (error) => {
          setIsSubmitting(false);
          toast.error("Something went wrong...")
          console.error(error);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <fieldset disabled={isSubmitting || isSubmited}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          placeholder="Name"
                          disabled={isSubmitting || isSubmited}
                          required
                          // onChange={handleChange}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder="Email"
                          required
                          disabled={isSubmitting || isSubmited}
                          // onChange={handleChange}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder="Message"
                      required
                      disabled={isSubmitting || isSubmited}
                      // onChange={handleChange}
                    ></textarea>
                    <p className="help-block text-danger"></p>
                  </div>
                  <div id="success"></div>
                  <button type="submit" className="btn btn-custom btn-lg" disabled={isSubmitting || isSubmited}>
                  { isSubmitting ? "Message Sending" : isSubmited ? "Message Sent" : "Send Message" }<i class="fa fa-spin" hidden={!isSubmitting} aria-hidden="true"></i>

                  </button>
                </fieldset>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                <a target="_blank" rel="noopener noreferrer" href="https://maps.app.goo.gl/wZ9TBRyQ8mZc6zC46">{props.data ? props.data.address : "loading"}</a>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-clock-o"></i> Hours
                </span>{" "}
                {"Monday - Saturday"}<br/>
                {"6:30 AM - 7:00 PM"}<br/><span></span>
                {"Sunday"}<br/>
                {"7:00 AM - 6:00 PM"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? <a href={"tel:" + props.data.phone}>{props.data.phone}</a> : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? <a href={"mailto:" + props.data.email}>{props.data.email}</a> : "loading"}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.instagram : "/"}>
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  {/* <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 K&L Delicatessen{" "}
          </p>
        </div>
      </div>
    </div>
  );
};
